export const i18nTexts = {
  pt: {
    nav: {
      work: 'Trabalhos',
      services: 'Serviços',
      price: 'Preços',
      contact: 'Contato',
    },
    hero: {
      tag: 'Editor · Designer · Gestor',
      title1: 'FRAME',
      title2: 'POR',
      title3: 'FRAME',
      sub: 'Criando experiências audiovisuais que capturam atenção e contam histórias que ficam. Edição, identidade visual e gestão de projetos em um único lugar.',
      cta1: 'Ver Trabalhos',
      cta2: 'Falar comigo',
      reel: 'SEU REEL · 2025',
    },
    stats: {
      projects: { num: '48+', label: 'Projetos entregues' },
      views: { num: '3M', label: 'Views acumuladas' },
      years: { num: '5+', label: 'Anos de experiência' },
    },
    work: {
      sectionNum: '01 — Portfólio',
      title1: 'SELE',
      title2: 'ÇÃO',
      viewAll: 'Ver todos',
    },
    services: {
      sectionNum: '02 — Serviços',
      title1: 'O QUE',
      title2: 'FAÇO',
      items: [
        {
          num: '01',
          title: 'EDIÇÃO DE VÍDEO',
          desc: 'Corte, color grading, motion graphics e sound design. Do bruto ao polido — narrativa que prende do primeiro ao último frame.',
          tags: ['Premiere', 'After Effects', 'DaVinci'],
        },
        {
          num: '02',
          title: 'THUMBNAIL DESIGN',
          desc: 'Composições que param o scroll. Hierarquia visual, CTR alto e identidade consistente para canais que querem crescer.',
          tags: ['Photoshop', 'Figma', 'A/B Test'],
        },
        {
          num: '03',
          title: 'GESTÃO AUDIOVISUAL',
          desc: 'Da pré-produção ao entregável final. Coordenação de equipe, cronograma, briefing e controle criativo para projetos ambiciosos.',
          tags: ['Produção', 'Direção', 'Gestão'],
        },
      ],
    },
    spotlight: {
      sectionNum: '03 — Destaque',
      title1: 'PROJETO',
      title2: 'EM FOCO',
      watchBtn: 'Assistir',
    },
    contact: {
      sectionNum: '04 — Contato',
      title1: 'VAMOS',
      title2: 'CRIAR',
      title3: 'ALGO',
      namePlaceholder: 'Como posso te chamar?',
      emailPlaceholder: 'seu@email.com',
      projectPlaceholder: 'Me conta sobre a ideia...',
      nameLabel: 'Seu nome',
      emailLabel: 'E-mail',
      projectLabel: 'Projeto',
      sendBtn: 'Enviar mensagem',
      success: 'Mensagem enviada! Em breve te retorno.',
      error: 'Erro ao enviar. Tente novamente.',
    },
    footer: {
      rights: '© 2025 — Todos os direitos reservados',
    },
  },

  en: {
    nav: {
      work: 'Work',
      services: 'Services',
      price: 'Pricing',
      contact: 'Contact',
    },
    hero: {
      tag: 'Editor · Designer · Manager',
      title1: 'FRAME',
      title2: 'BY',
      title3: 'FRAME',
      sub: 'Creating audiovisual experiences that capture attention and tell stories that last. Editing, visual identity and project management — all in one place.',
      cta1: 'See Work',
      cta2: 'Get in touch',
      reel: 'YOUR REEL · 2025',
    },
    stats: {
      projects: { num: '48+', label: 'Projects delivered' },
      views: { num: '3M', label: 'Accumulated views' },
      years: { num: '5+', label: 'Years of experience' },
    },
    work: {
      sectionNum: '01 — Portfolio',
      title1: 'SELEC',
      title2: 'TION',
      viewAll: 'View all',
    },
    services: {
      sectionNum: '02 — Services',
      title1: 'WHAT',
      title2: 'I DO',
      items: [
        {
          num: '01',
          title: 'VIDEO EDITING',
          desc: 'Cut, color grading, motion graphics and sound design. From raw footage to polished — narrative that hooks from first to last frame.',
          tags: ['Premiere', 'After Effects', 'DaVinci'],
        },
        {
          num: '02',
          title: 'THUMBNAIL DESIGN',
          desc: 'Compositions that stop the scroll. Visual hierarchy, high CTR and consistent identity for channels that want to grow.',
          tags: ['Photoshop', 'Figma', 'A/B Test'],
        },
        {
          num: '03',
          title: 'AUDIOVISUAL MANAGEMENT',
          desc: 'From pre-production to final deliverable. Team coordination, scheduling, briefing and creative control for ambitious projects.',
          tags: ['Production', 'Direction', 'Management'],
        },
      ],
    },
    spotlight: {
      sectionNum: '03 — Spotlight',
      title1: 'PROJECT',
      title2: 'IN FOCUS',
      watchBtn: 'Watch',
    },
    contact: {
      sectionNum: '04 — Contact',
      title1: "LET'S",
      title2: 'CREATE',
      title3: 'SOMETHING',
      namePlaceholder: "What's your name?",
      emailPlaceholder: 'your@email.com',
      projectPlaceholder: 'Tell me about your idea...',
      nameLabel: 'Your name',
      emailLabel: 'E-mail',
      projectLabel: 'Project',
      sendBtn: 'Send message',
      success: 'Message sent! I will get back to you soon.',
      error: 'Error sending. Please try again.',
    },
    footer: {
      rights: '© 2025 — All rights reserved',
    },
  },
};
